import { AsyncStateStatus } from '../root.types'
import { UsersState } from './types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'
import { User } from '../../application/domain/models/entity/user'

const initialState: UsersState = {
    userLogged: {
        status: AsyncStateStatus.INITIAL,
        user: {
            name: '',
            type: '',
            email: '',
            id: '',
            cpf: '',
            organization_id: '',
            organization_logo: null,
            institutional_position: '',
            institutional_registration: '',
            phone: '',
            uf_logo: null
        }
    },
    request: {
        admins: {
            request: {
                data: [],
                status: AsyncStateStatus.INITIAL
            },
            newUser: AsyncStateStatus.INITIAL,
            editUser: {
                status :AsyncStateStatus.INITIAL
            }
        },
        analyst: {
            request: {
                data: [],
                status: AsyncStateStatus.INITIAL
            },
            newUser: AsyncStateStatus.INITIAL,
            editUser: {
                status: AsyncStateStatus.INITIAL,
                data: new User()
            },
            changeResources: AsyncStateStatus.INITIAL
        }
    },
    org: {
        getAll: {
            data: [],
            status: AsyncStateStatus.INITIAL
        },
        newOrg: {
            status: AsyncStateStatus.INITIAL
        },
        getUsersByOrg: {
            data: [],
            status: AsyncStateStatus.INITIAL
        },
        orgResponsibles: {
            status: AsyncStateStatus.INITIAL
        },
        orgUpdate: {
            status: AsyncStateStatus.INITIAL
        },
        orgFind: {
            status: AsyncStateStatus.INITIAL,
            data: null
        },
        orgActUpload: {
            status: AsyncStateStatus.INITIAL,
            idOrg: ''
        },
        orgActDownload: {
            status: AsyncStateStatus.INITIAL,
            data: null
        },
        orgActDelete: {
            status: AsyncStateStatus.INITIAL
        }
    },
    userActive: AsyncStateStatus.INITIAL,
    analystRequest: AsyncStateStatus.INITIAL,
    usersRequest: {
        status: AsyncStateStatus.INITIAL,
        data: []
    },
    findUserRequest: {
        status: AsyncStateStatus.INITIAL,
        data: []
    },
    deleteUserRequest: AsyncStateStatus.INITIAL,
    orgName: {
        status: AsyncStateStatus.INITIAL,
        data: []
    },
    ufRequest: {
        status: AsyncStateStatus.INITIAL,
        data: []
    },
    orgLogo: AsyncStateStatus.INITIAL,
    logsUser: {
        status: AsyncStateStatus.INITIAL,
        data: []
    }
}

export const userSlice = createSlice({
    name: '@users',
    initialState,
    reducers: {
        userRequest: (state: Draft<UsersState>) => {
            state.userLogged.status = AsyncStateStatus.LOADING
        },
        userSuccess: (state: Draft<UsersState>, action: PayloadAction<{ data: any } >) => {
            state.userLogged.status = AsyncStateStatus.SUCCESS
            state.userLogged.user = action.payload.data
        },
        userFailure: (state: Draft<UsersState>) => {
            state.userLogged.status = AsyncStateStatus.FAILURE
        },
        adminRequest: (state: Draft<UsersState>) => {
            state.request.admins.request.status = AsyncStateStatus.LOADING
        },
        adminSuccess: (state: Draft<UsersState>, action: PayloadAction<{ data: any } >) => {
            state.request.admins.request.data = action.payload.data
            state.request.admins.request.status = AsyncStateStatus.SUCCESS
        },
        adminFailure: (state: Draft<UsersState>) => {
            state.request.admins.request.status = AsyncStateStatus.FAILURE
        },
        newAdminRequest: (state: Draft<UsersState>) => {
            state.request.admins.newUser = AsyncStateStatus.LOADING
        },
        newAdminSuccess: (state: Draft<UsersState>) => {
            state.request.admins.newUser = AsyncStateStatus.SUCCESS
        },
        newAdminFailure: (state: Draft<UsersState>) => {
            state.request.admins.newUser = AsyncStateStatus.FAILURE
        },
        editAdminRequest: (state: Draft<UsersState>) => {
            state.request.admins.editUser.status = AsyncStateStatus.LOADING
        },
        editAdminSuccess: (state: Draft<UsersState>) => {
            state.request.admins.editUser.status = AsyncStateStatus.SUCCESS
        },
        editAdminFailure: (state: Draft<UsersState>) => {
            state.request.admins.editUser.status = AsyncStateStatus.FAILURE
        },
        analystRequest: (state: Draft<UsersState>) => {
            state.request.analyst.request.status = AsyncStateStatus.LOADING
        },
        analystSuccess: (state: Draft<UsersState>, action: PayloadAction<{ data: any } >) => {
            state.request.analyst.request.data = action.payload.data
            state.request.analyst.request.status = AsyncStateStatus.SUCCESS
        },
        analystFailure: (state: Draft<UsersState>) => {
            state.request.analyst.request.status = AsyncStateStatus.FAILURE
        },
        newAnalystRequest: (state: Draft<UsersState>) => {
            state.request.analyst.newUser = AsyncStateStatus.LOADING
        },
        newAnalystSuccess: (state: Draft<UsersState>) => {
            state.request.analyst.newUser = AsyncStateStatus.SUCCESS
        },
        newAnalystFailure: (state: Draft<UsersState>) => {
            state.request.analyst.newUser = AsyncStateStatus.FAILURE
        },
        editAnalystRequest: (state: Draft<UsersState>) => {
            state.request.analyst.editUser.status = AsyncStateStatus.LOADING
        },
        editAnalystSuccess: (state: Draft<UsersState>, action:PayloadAction<{ data: any }>) => {
            state.request.analyst.editUser.status = AsyncStateStatus.SUCCESS
            state.request.analyst.editUser.data = action.payload.data
        },
        editAnalystFailure: (state: Draft<UsersState>) => {
            state.request.analyst.editUser.status = AsyncStateStatus.FAILURE
        },
        changeResourcesRequest: (state: Draft<UsersState>) => {
            state.request.analyst.changeResources = AsyncStateStatus.LOADING
        },
        changeResourcesSuccess: (state: Draft<UsersState>) => {
            state.request.analyst.changeResources = AsyncStateStatus.SUCCESS
        },
        changeResourcesFailure: (state: Draft<UsersState>) => {
            state.request.analyst.changeResources = AsyncStateStatus.FAILURE
        },
        newOrgRequest: (state: Draft<UsersState>) => {
            state.org.newOrg.status = AsyncStateStatus.LOADING
        },
        newOrgRequestSucess: (state: Draft<UsersState>, action: PayloadAction<{ data: any } >) => {
            state.org.newOrg.status = AsyncStateStatus.SUCCESS
            state.org.orgActUpload.idOrg = action.payload.data.idOrg
        },
        newOrgRequestFailure: (state: Draft<UsersState>) => {
            state.org.newOrg.status = AsyncStateStatus.FAILURE
        },
        orgsRequest: (state: Draft<UsersState>) => {
            state.org.getAll.status = AsyncStateStatus.LOADING
        },
        orgsRequestSucess: (state: Draft<UsersState>, action: PayloadAction<{ data: any } >) => {
            state.org.getAll.status = AsyncStateStatus.SUCCESS
            state.org.getAll.data = action.payload.data
        },
        orgsRequestFailure: (state: Draft<UsersState>) => {
            state.org.getAll.status = AsyncStateStatus.FAILURE
        },
        getUersByOrg: (state: Draft<UsersState>) => {
            state.org.getUsersByOrg.status = AsyncStateStatus.LOADING
        },
        getUersByOrgSucess: (state: Draft<UsersState>, action: PayloadAction<{ data: any } >) => {
            state.org.getUsersByOrg.status = AsyncStateStatus.SUCCESS
            state.org.getUsersByOrg.data = action.payload.data
        },
        getUersByOrgFailure: (state: Draft<UsersState>) => {
            state.org.getUsersByOrg.status = AsyncStateStatus.FAILURE
        },
        orgResponsibles: (state: Draft<UsersState>) => {
            state.org.orgResponsibles.status = AsyncStateStatus.LOADING
        },
        orgResponsiblesSucess: (state: Draft<UsersState>) => {
            state.org.orgResponsibles.status = AsyncStateStatus.SUCCESS
        },
        orgResponsiblesFailure: (state: Draft<UsersState>) => {
            state.org.orgResponsibles.status = AsyncStateStatus.FAILURE
        },
        orgsFindRequest: (state: Draft<UsersState>) => {
            state.org.orgFind.status = AsyncStateStatus.LOADING
        },
        orgsFindRequestSucess: (state: Draft<UsersState>, action: PayloadAction<{ data: any }>) => {
            state.org.orgFind.status = AsyncStateStatus.SUCCESS
            state.org.orgFind.data = action.payload.data
        },
        orgsFindRequestFailure: (state: Draft<UsersState>) => {
            state.org.orgFind.status = AsyncStateStatus.FAILURE
        },
        orgsUpdateRequest: (state: Draft<UsersState>) => {
            state.org.orgUpdate.status = AsyncStateStatus.LOADING
        },
        orgsUpdateRequestSucess: (state: Draft<UsersState>) => {
            state.org.orgUpdate.status = AsyncStateStatus.SUCCESS
        },
        orgsUpdateRequestFailure: (state: Draft<UsersState>) => {
            state.org.orgUpdate.status = AsyncStateStatus.FAILURE
        },
        userActiveRequest: (state: Draft<UsersState>) => {
            state.userActive = AsyncStateStatus.LOADING
        },
        userActiveSucess: (state: Draft<UsersState>) => {
            state.userActive = AsyncStateStatus.SUCCESS
        },
        userActiveFailure: (state: Draft<UsersState>) => {
            state.userActive = AsyncStateStatus.FAILURE
        },
        orgsActUpload: (state: Draft<UsersState>) => {
            state.org.orgActUpload.status = AsyncStateStatus.LOADING
        },
        orgsActUploadSuccess: (state: Draft<UsersState>) => {
            state.org.orgActUpload.status = AsyncStateStatus.SUCCESS
        },
        orgsActUploadFailure: (state: Draft<UsersState>) => {
            state.org.orgActUpload.status = AsyncStateStatus.FAILURE
        },
        orgsActDownload: (state: Draft<UsersState>) => {
            state.org.orgActDownload.status = AsyncStateStatus.LOADING
        },
        orgsActDownloadSuccess: (state: Draft<UsersState>) => {
            state.org.orgActDownload.status = AsyncStateStatus.SUCCESS
        },
        orgsActDownloadFailure: (state: Draft<UsersState>) => {
            state.org.orgActDownload.status = AsyncStateStatus.FAILURE
        },
        signupRequest: (state: Draft<UsersState>) => {
            state.analystRequest = AsyncStateStatus.LOADING
        },
        signupRequestSuccess: (state: Draft<UsersState>) => {
            state.analystRequest = AsyncStateStatus.SUCCESS
        },
        signupRequestFailure: (state: Draft<UsersState>) => {
            state.analystRequest = AsyncStateStatus.FAILURE
        },
        usersRequest: (state: Draft<UsersState>) => {
            state.usersRequest.status = AsyncStateStatus.LOADING
        },
        usersRequestSuccess: (state: Draft<UsersState>, action: PayloadAction<{ data: any }>) => {
            state.usersRequest.status = AsyncStateStatus.SUCCESS
            state.usersRequest.data = action.payload.data
        },
        usersRequestFailure: (state: Draft<UsersState>) => {
            state.usersRequest.status = AsyncStateStatus.FAILURE
        },
        findOneUserRequest: (state: Draft<UsersState>) => {
            state.findUserRequest.status = AsyncStateStatus.LOADING
        },
        findOneUserRequestSuccess: (state: Draft<UsersState>, action: PayloadAction<{ data: any }>) => {
            state.findUserRequest.status = AsyncStateStatus.SUCCESS
            state.findUserRequest.data = action.payload.data
        },
        findOneUserRequestFailure: (state: Draft<UsersState>) => {
            state.findUserRequest.status = AsyncStateStatus.FAILURE
        },
        deleteUsersRequest: (state: Draft<UsersState>) => {
            state.deleteUserRequest = AsyncStateStatus.LOADING
        },
        deleteUsersRequestSuccess: (state: Draft<UsersState>) => {
            state.deleteUserRequest = AsyncStateStatus.SUCCESS
        },
        deleteUsersRequestFailure: (state: Draft<UsersState>) => {
            state.deleteUserRequest = AsyncStateStatus.FAILURE
        },
        orgNameRequest: (state: Draft<UsersState>) => {
            state.orgName.status = AsyncStateStatus.LOADING
        },
        orgNameRequestSuccess: (state: Draft<UsersState>, action: PayloadAction<{ data: any }>) => {
            state.orgName.status = AsyncStateStatus.SUCCESS
            state.orgName.data = action.payload.data
        },
        orgNameRequestFailure: (state: Draft<UsersState>) => {
            state.orgName.status = AsyncStateStatus.FAILURE
        },
        ufRequest: (state: Draft<UsersState>) => {
            state.ufRequest.status = AsyncStateStatus.LOADING
        },
        ufRequestSuccess: (state: Draft<UsersState>, action: PayloadAction<{ data: any }>) => {
            state.ufRequest.status = AsyncStateStatus.SUCCESS
            state.ufRequest.data = action.payload.data
        },
        ufRequestFailure: (state: Draft<UsersState>) => {
            state.ufRequest.status = AsyncStateStatus.FAILURE
        },
        orgLogoRequest: (state: Draft<UsersState>) => {
            state.orgLogo = AsyncStateStatus.LOADING
        },
        orgLogoRequestSuccess: (state: Draft<UsersState>) => {
            state.orgLogo = AsyncStateStatus.SUCCESS
        },
        orgLogoRequestFailure: (state: Draft<UsersState>) => {
            state.orgLogo = AsyncStateStatus.FAILURE
        },
        logsUserRequest: (state: Draft<UsersState>) => {
            state.logsUser.status = AsyncStateStatus.LOADING
        },
        logsUserSuccess: (state: Draft<UsersState>, action: PayloadAction<{ data: any }>) => {
            state.logsUser.status = AsyncStateStatus.SUCCESS
            state.logsUser.data = action.payload.data
        },
        logsUserFailure: (state: Draft<UsersState>) => {
            state.logsUser.status = AsyncStateStatus.FAILURE
        },
    }
})

/**
 * <h5>Functions that trigger actions related to authentication in the system.</h5>
 * @see {@link https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions}
 * @typedef CompanyActions
 * @namespace CompanyActions
 * @category React
 * @subcategory Redux / Actions
 * @property {Function} userRequest
 * @property {Function} userSuccess
 * @property {Function} userFailure
 * @property {Function} adminRequest
 * @property {Function} adminSuccess
 * @property {Function} adminFailure
 * @property {Function} newAdminRequest
 * @property {Function} newAdminSuccess
 * @property {Function} newAdminFailure
 * @property {Function} newAnalystRequest
 * @property {Function} newAnalystSuccess
 * @property {Function} newAnalystFailure
 * @property {Function} editAdminRequest
 * @property {Function} editAdminSuccess
 * @property {Function} editAdminSuccess
 * @property {Function} editAnalystRequest
 * @property {Function} editAnalystSuccess
 * @property {Function} editAnalystSuccess
 */
export const UsersActions = userSlice.actions

export default userSlice.reducer
